export default "__VITE_ASSET__BbKloerl__"